import React from 'react';
import { colors } from '@styleseat/brand';

type CloseIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CloseIcon = ({
  width = 24,
  height = 24,
  viewBox = '0 0 24 24',
  color = colors.blackInBlack,
}: CloseIconProps) => (
  <svg
    fill="none"
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Close Icon</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.347614 17.8647C-0.116026 18.353 -0.115849 19.1444 0.34801 19.6324C0.811868 20.1204 1.56375 20.1202 2.02739 19.632L9.35921 11.9155C9.39634 11.8763 9.44675 11.8543 9.49932 11.8543C9.5519 11.8543 9.60231 11.8763 9.63944 11.9155L16.9713 19.6337C17.2712 19.9495 17.7084 20.0729 18.1182 19.9575C18.528 19.842 18.8482 19.5051 18.9581 19.0738C19.068 18.6425 18.951 18.1822 18.651 17.8664L11.32 10.1465C11.2828 10.1074 11.2619 10.0544 11.2619 9.99903C11.2619 9.94369 11.2828 9.89063 11.32 9.85155L18.6526 2.13418C19.1163 1.64547 19.1157 0.85367 18.6514 0.36565C18.1871 -0.122371 17.4349 -0.121811 16.9713 0.3669L9.63944 8.0826C9.60231 8.12178 9.5519 8.1438 9.49932 8.1438C9.44675 8.1438 9.39634 8.12178 9.35921 8.0826L2.02739 0.3669C1.56375 -0.121351 0.811868 -0.121538 0.34801 0.366483C-0.115849 0.854504 -0.116026 1.64593 0.347614 2.13418L7.67864 9.85155C7.71586 9.89063 7.73678 9.94369 7.73678 9.99903C7.73678 10.0544 7.71586 10.1074 7.67864 10.1465L0.347614 17.8647Z"
      fill={color}
    />
  </svg>
);

export default CloseIcon;
